import { useMutation } from '@tanstack/react-query'
import { MemberApi } from '@/domains/auth/api'
import { getAuthStore } from '@/domains/auth/model/store.ts'

export function useLogoutMutation() {
  return useMutation({
    mutationFn: () => MemberApi.logout(),
    onSettled: () => getAuthStore().removeToken(),
  })
}
